import { render, staticRenderFns } from "./TheAcceptChatWindow.vue?vue&type=template&id=a4ef4260&scoped=true"
import script from "./TheAcceptChatWindow.vue?vue&type=script&lang=js"
export * from "./TheAcceptChatWindow.vue?vue&type=script&lang=js"
import style0 from "./TheAcceptChatWindow.vue?vue&type=style&index=0&id=a4ef4260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ef4260",
  null
  
)

export default component.exports